// Syntetizované náhrady zvuků UNO.
// Jakmile v /sounds/manifest.json bude soubor se stejným jménem, použije se místo nich.
import { noise, registerSynth, tone } from "../../audio.ts";

// Pohyb po ruce: hratelná karta má vlastní cinknutí, nehratelná běžný „kurzor“.
registerSynth("uno-hratelna", (c, o, t) => {
  tone(c, o, t, 880, 0.09, { type: "triangle", gain: 0.3, to: 1320, attack: 0.003 });
  return 0.1;
});
registerSynth("uno-zahrani", (c, o, t) => {
  noise(c, o, t, 0.1, { freq: 1500, q: 0.7, gain: 0.4 });
  return 0.1;
});
registerSynth("uno-lizani", (c, o, t) => {
  noise(c, o, t, 0.25, { freq: 4000, q: 0.5, gain: 0.25 });
  return 0.25;
});
registerSynth("uno-stop", (c, o, t) => {
  tone(c, o, t, 600, 0.12, { type: "square", gain: 0.12 });
  tone(c, o, t + 0.14, 600, 0.2, { type: "square", gain: 0.12 });
  return 0.35;
});
registerSynth("uno-otocka", (c, o, t) => {
  tone(c, o, t, 400, 0.2, { to: 900, gain: 0.25 });
  tone(c, o, t + 0.2, 900, 0.2, { to: 400, gain: 0.25 });
  return 0.4;
});
registerSynth("uno-plus", (c, o, t) => {
  [330, 440, 554].forEach((f, i) => tone(c, o, t + i * 0.08, f, 0.15, { type: "triangle", gain: 0.25 }));
  return 0.35;
});
registerSynth("uno-zmena", (c, o, t) => {
  [262, 330, 392, 523, 659, 784].forEach((f, i) => tone(c, o, t + i * 0.05, f, 0.2, { gain: 0.18 }));
  return 0.5;
});
registerSynth("uno-volani", (c, o, t) => {
  tone(c, o, t, 523, 0.15, { type: "triangle", gain: 0.3 });
  tone(c, o, t + 0.17, 784, 0.35, { type: "triangle", gain: 0.3 });
  return 0.55;
});
